import { useState } from 'react';
import BookingModal from '../../../components/feature/BookingModal';

export default function HeroSection() {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);

  return (
    <>
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/eaeb9aa057931404133713d534e32458.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-32">
          <div className="text-center space-y-6 md:space-y-8">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
              대전 최고의 렌터카 서비스
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-white/90 max-w-3xl mx-auto leading-relaxed px-4">
              합리적인 가격과 최상의 서비스로 고객님의 여행을 책임집니다.전자총 자차보험가입,딜리버리서비스,최신형 차량 보유등 최고의 서비스로 차량을 이용하실 수 있습니다
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4 md:pt-8 px-4">
              <a
                href="tel:010-5437-1535"
                className="w-full sm:w-auto px-6 md:px-8 py-3 md:py-4 bg-white/10 backdrop-blur-sm text-white text-sm md:text-base font-semibold rounded-lg border-2 border-white/30 hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                전화 상담하기
              </a>
            </div>

            {/* Features */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-8 pt-8 md:pt-16 px-4">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-6 border border-white/20">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-primary/20 rounded-full mx-auto mb-3 md:mb-4">
                  <i className="ri-car-line text-2xl md:text-3xl text-white"></i>
                </div>
                <h3 className="text-base md:text-lg font-semibold text-white mb-2">다양한 차종</h3>
                <p className="text-xs md:text-sm text-white/80">소형차부터 대형 SUV까지 원하시는 차량을 선택하세요</p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-6 border border-white/20">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-primary/20 rounded-full mx-auto mb-3 md:mb-4">
                  <i className="ri-price-tag-3-line text-2xl md:text-3xl text-white"></i>
                </div>
                <h3 className="text-base md:text-lg font-semibold text-white mb-2">합리적인 가격</h3>
                <p className="text-xs md:text-sm text-white/80">경쟁력 있는 가격으로 최고의 가성비를 제공합니다</p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-6 border border-white/20">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-primary/20 rounded-full mx-auto mb-3 md:mb-4">
                  <i className="ri-customer-service-2-line text-2xl md:text-3xl text-white"></i>
                </div>
                <h3 className="text-base md:text-lg font-semibold text-white mb-2">24시간 상담 문의</h3>
                <p className="text-xs md:text-sm text-white/80">언제든지 문의하시면 신속하게 도와드립니다</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <BookingModal isOpen={isBookingModalOpen} onClose={() => setIsBookingModalOpen(false)} />
    </>
  );
}
